import useIsMobile from '@/util/useIsMobile'
import { useRecoilValue } from 'recoil'
import { subDataState } from '@/util/states'
import { useApiCall } from 'src/hooks/useApiCall'
import { useRouter } from 'next/router'
import BlogList from '../../components/Blog/BlogList'
import SectionList from './SectionList'

export default function Section() {
  const router  = useRouter();
  const { tag } = router.query

  const blogEntriesData = useApiCall({contentType: 'blogPost', order: '-fields.datePublished', options: { match: tag }})

  const isMobile = useIsMobile()
  const subData = useRecoilValue(subDataState)

  if (isMobile === undefined) return null
  if (subData === 'pending') return null

  return (
    <div className="w-full">
      <div className="dt:max-w-full mx-auto dt:px-6">
        {tag && <BlogList blogEntriesData={blogEntriesData} isMobile={isMobile} subData={subData} />}
        <SectionList />
      </div>
    </div>
  )
}
